import Footer from "components/Footer";
import Header from "components/Header";
import MainTitle from "components/MainTitle";
import QuickDonate from "components/QuickDonate/QuickDonate";
import { useSelector } from "react-redux";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { RootState } from "redux/rootReducer";
import { useTranslation } from "react-i18next";

const BoardOfDirectors = () => {
  const { t, i18n } = useTranslation();
  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  return (
    <>
      <Header />

      <main className="relative">
        {/* quick donate  */}
        <QuickDonate />

        {/* quick donate popup  */}
        {quickDonateStatus && <QuickDonatePopUp />}

        <MainTitle title={t("Board of Directors")} />

        {/* directors section  */}
        <section className="my-[50px] w-full p-[20px] lg:px-0">
          <div className="mainContainer">
            {/* description  ***********************/}
            <div
              className={`mb-[100px] mt-[50px] text-second_color text-[20px] font-[600] ${
                i18n.language === "en" ? "font-Poppins" : "font-Almarai"
              }`}
            >
              {t(
                "The Board of Trustees of the Al Etihad Charity Foundation and the senior management include a group of statesmen who have connections and a long history in administrative leadership and charitable work at the level of the local governmental and charity institutions of the Emirate of Ajman. It consists of:"
              )}
            </div>

            {/* Chairman of th,e Board of Trustees */}
            <div className="flex items-center justify-center">
              <div className="w-full lg:w-[588px] h-[203px] p-[20px] border border-first_color flex flex-col items-center justify-end group">
                <img
                  className="group-hover:scale-[1.1] duration-500"
                  src="images/Nuaimi.png"
                  alt=""
                />

                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[600] text-second_color text-[14px] lg:text-[16px]`}
                >
                  {t("Sheikh Mohammed bin Ali bin Rashid Al Nuaimi")}
                </p>

                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[400] text-[12px] lg:text-[14px] text-[#444444]`}
                >
                  {t("Chairman of the Board of Trustees")}
                </p>
              </div>
            </div>

            {/* the grid of the other people  ******/}
            <div className="my-[120px] w-full grid grid-cols-1 lg:grid-cols-2 gap-[120px]">
              {/* one */}
              <div
                data-aos="fade-up"
                data-aos-duration="900"
                className="col-span-1 h-[203px] p-[20px] border border-first_color flex flex-col items-center justify-end group"
              >
                <img
                  className="group-hover:scale-[1.1] duration-500"
                  src="images/Rashid.png"
                  alt=""
                />

                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[600] text-second_color text-[14px] lg:text-[16px]`}
                >
                  {t("Sheikh Rashid bin Mohammed bin Ali Al Nuaimi")}
                </p>

                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[400] text-[12px] lg:text-[14px] text-[#444444]`}
                >
                  {t("Vice President of the Board of Trustees")}
                </p>
              </div>

              {/* two  */}
              <div
                data-aos="fade-up"
                data-aos-duration="900"
                className="col-span-1 h-[203px] p-[20px] border border-first_color flex flex-col items-center justify-end group"
              >
                <img
                  className="group-hover:scale-[1.1] duration-1000"
                  src="images/Muwaiji.png"
                  alt=""
                />

                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[600] text-second_color text-[14px] lg:text-[16px]`}
                >
                  {t("Abdullah Mohammed Al Muwaiji")}
                </p>

                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[400] text-[12px] lg:text-[14px] text-[#444444]`}
                >
                  {t("Member of the Board of Trustees")}
                </p>
              </div>

              {/* three */}
              <div
                data-aos="fade-up"
                data-aos-duration="900"
                className="col-span-1 h-[203px] p-[20px] border border-first_color flex flex-col items-center justify-end group"
              >
                <img
                  className="group-hover:scale-[1.1] duration-1000"
                  src="images/Erian.png"
                  alt=""
                />

                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[600] text-second_color text-[14px] lg:text-[16px]`}
                >
                  {t("Hareb Salem Al-Erian")}
                </p>

                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[400] text-[12px] lg:text-[14px] text-[#444444]`}
                >
                  {t("Secretary General")}
                </p>
              </div>

              {/* four */}
              <div
                data-aos="fade-up"
                data-aos-duration="900"
                className="col-span-1 h-[203px] p-[20px] border border-first_color flex flex-col items-center justify-end group"
              >
                <img
                  className="group-hover:scale-[1.1] duration-1000"
                  src="images/Shamsi.png"
                  alt=""
                />

                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[600] text-second_color text-[14px] lg:text-[16px]`}
                >
                  {t("Rashid Abdullah Al Shamsi")}
                </p>

                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[400] text-[12px] lg:text-[14px] text-[#444444]`}
                >
                  {t("Board of Trustees members")}
                </p>
              </div>

              {/* five */}
              <div
                data-aos="fade-up"
                data-aos-duration="900"
                className="col-span-1 h-[203px] p-[20px] border border-first_color flex flex-col items-center justify-end group"
              >
                <img
                  className="group-hover:scale-[1.1] duration-1000"
                  src="images/AlNuaimi.png"
                  alt=""
                />

                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[600] text-second_color text-[14px] lg:text-[16px]`}
                >
                  {t("Sheikh Ali bin Muhammad bin Ali Al Nuaimi")}
                </p>

                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[400] text-[12px] lg:text-[14px] text-[#444444]`}
                >
                  {t("Executive Director")}
                </p>
              </div>

              {/* six */}
              <div
                data-aos="fade-up"
                data-aos-duration="900"
                className="col-span-1 h-[203px] p-[20px] border border-first_color flex flex-col items-center justify-end group"
              >
                <img
                  className="group-hover:scale-[1.1] duration-1000"
                  src="images/Junaibi.png"
                  alt=""
                />

                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[600] text-second_color text-[14px] lg:text-[16px]`}
                >
                  {t("Nasser Ali Al-Junaibi")}
                </p>

                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[400] text-[12px] lg:text-[14px] text-[#444444]`}
                >
                  {t("chief executive officer")}
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default BoardOfDirectors;
